import * as yup from "yup";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import { useTranslation } from "react-i18next";
import FormDatePicker from "../../../../../../shared/components/datepicker/FormDatePicker";
import FormInput from "../../../../../../shared/components/input/FormInput";
import FormSelect from "../../../../../../shared/components/select/FormSelect";
import FormSwitch from "../../../../../../shared/components/switch/FormSwitch";

const UpdateClientPlatformMarginsForm = ({
  onSubmitHandler,
  clients,
  platforms,
  clientPlatformMargin,
  platform,
}) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    beginDate: yup
      .date()
      .required(
        t("clientPlatformMargins.updateForm.fields.beginDate.required"),
      ),
    endDate: yup
      .date()
      .required(t("clientPlatformMargins.updateForm.fields.endDate.required")),
    clientId: yup
      .string()
      .required(t("clientPlatformMargins.updateForm.fields.client.required")),
    platformId: yup
      .string()
      .required(t("clientPlatformMargins.updateForm.fields.platform.required")),
    margin: yup
      .number()
      .required(t("clientPlatformMargins.updateForm.fields.margin.required")),
  });

  const defaultValues = {
    beginDate: new Date(clientPlatformMargin.beginDate),
    endDate: new Date(clientPlatformMargin.endDate),
    clientId: clientPlatformMargin.client.id,
    platformId: platform.id,
    margin: clientPlatformMargin.margin,
    comments: clientPlatformMargin.comments,
    marginInPlatform: clientPlatformMargin.marginInPlatform,
  };

  return (
    <BaseForm
      onSubmitHandler={onSubmitHandler}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      isCreationForm={false}
    >
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormDatePicker
            name="beginDate"
            label={t("clientPlatformMargins.updateForm.fields.beginDate.label")}
            required
          />
        </div>
        <div className="w-1/2">
          <FormDatePicker
            name="endDate"
            label={t("clientPlatformMargins.updateForm.fields.endDate.label")}
            required
          />
        </div>
      </div>
      <div className="flex flex-row justify-between gap-x-4 w-full">
        <div className="w-1/2">
          <FormInput
            name="comments"
            label={t("clientPlatformMargins.updateForm.fields.comments.label")}
            placeholder={t(
              "clientPlatformMargins.updateForm.fields.comments.placeholder",
            )}
          />
        </div>
        <div className="w-1/2">
          <FormInput
            type="number"
            name="margin"
            label={t("clientPlatformMargins.updateForm.fields.margin.label")}
            required
          />
        </div>
      </div>
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormSelect
            name="clientId"
            label={t("clientPlatformMargins.updateForm.fields.client.label")}
            options={clients}
            disabled={true}
          />
        </div>
        <div className="w-1/2">
          <FormSelect
            name="platformId"
            label={t("clientPlatformMargins.updateForm.fields.platform.label")}
            options={platforms}
            disabled={true}
          />
        </div>
      </div>
      <FormSwitch
        name="marginInPlatform"
        label={t(
          "clientPlatformMargins.updateForm.fields.marginInPlatform.label",
        )}
      />
    </BaseForm>
  );
};

export default UpdateClientPlatformMarginsForm;
